import PropTypes from "prop-types";
import React, { Component } from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { MODES } from "../../../constants";
import * as R from "ramda";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getters } from "SendEmailModal/model";
import * as SEND_TO_OPTION_TYPES from "SendEmailModal/utils/send-to-option-types";
import { particularContactsSelectedArray } from "SendEmailModal/selectors";

@CSSModules(css)
class Send extends Component {
  render() {
    const validFilter =
      this.props.mode === MODES.SMS
        ? r => r.meta.hasValidPhone
        : r => r.meta.hasValidEmail;

    const selectedContacts = this.props.particularContactsSelectedArray;
    const validRecipients =
      SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS !==
      this.props.selectedOptions
        ? this.props.recipients.filter(validFilter)
        : R.filter(
            contact =>
              selectedContacts.some(selectedContact => {
                return (
                  R.pathOr("", ["meta", "id"])(contact) ===
                  R.pathOr("", ["id"])(selectedContact)
                );
              }),
            this.props.recipients.filter(validFilter)
          );

    return (
      <div styleName="checkWrapper">
        <div styleName="checkIcon">
          <i className="material-icons">check</i>
        </div>
        <div styleName="titleReady">
          {validRecipients.length}{" "}
          {this.props.mode === MODES.SMS
            ? validRecipients.length === 1
              ? "message"
              : "messages"
            : validRecipients.length === 1
            ? "email"
            : "emails"}{" "}
          {validRecipients.length === 1 ? "was" : "were"} successfully sent
        </div>
      </div>
    );
  }
}
const decorate = R.compose(
  withRouter,
  connect(
    state => ({
      particularContactsSelected: getters.particularContactsSelected(state),
      particularContactsSelectedArray: particularContactsSelectedArray(state),
      selectedOptions: getters.selectedOptions(state)
    }),
    {}
  )
);

Send.propTypes = {
  recipients: PropTypes.array.isRequired
};

export default decorate(Send);
